import TYPES from './types';
import COMMON_TYPES from '../../../actions/types';
import { showNotificationLayer } from '../../../actions/notification';
import { create as c, update as u, details } from '../../../api/common';

const searchDetails = id =>
  details({ id, path: 'survey.php' })
    .then(response => ({
        type: TYPES.loadDataEdit,
        payload: response,
      })
    )
    .catch(() => ({ type: TYPES.loadingFormManagerEditError }))

const loadingPostManager = () => ({
  type: TYPES.loadingPostFormManager,
});

export const update = params => {
  return dispatch => {
    dispatch(loadingPostManager());

    u(params.formParams, 'survey.php')
      .then(response => {
        dispatch(loadingPostManager());
        dispatch(hideFormManagerLayer());

        dispatch({
          type: TYPES.updateItemListingManagerSuccess,
          payload: response,
        });

        dispatch(showNotificationLayer(
          `A enquete ${response.data.reference} foi atualizada!`
        ));
      })
      .catch(responseFail => {
        dispatch(loadingPostManager());

        dispatch({
          type: TYPES.formManagerPostError,
          payload: responseFail.response,
        });
      })
  }
}

export const create = params => {
  return dispatch => {
    dispatch(loadingPostManager());

    c(params.formParams, 'survey.php')
      .then(response => {
        dispatch(loadingPostManager());

        dispatch(
          showNotificationLayer(`A enquete ${response.data.reference} foi criada!`)
        );
      })
      .then(() => { params.callbackSuccess(); })
      .catch(responseFail => {
        dispatch(loadingPostManager());

        dispatch({
          type: TYPES.formManagerPostError,
          payload: responseFail.response,
        });
      })
  }
}

export const changeField = (values, type) => ({
  type: TYPES[type],
  payload: values,
});

export const showFormManagerLayer = params => {
  if(params && params.id) {
    return [
      { type: COMMON_TYPES.toggleLayer, payload: 'manager' },
      { type: TYPES.loadingFormManagerEdit },
      searchDetails(params.id),
    ];
  }

  return { type: COMMON_TYPES.toggleLayer, payload: 'manager' }
};

export const hideFormManagerLayer = () => [
  { type: COMMON_TYPES.toggleLayer, payload: null },
  { type: TYPES.clearFormManager }
];
